import { PROMOTION_BANNER_VIEWED } from 'trial-components-library/tracking/promotionTracking';
import { getPrimaryTracker } from 'usage-tracker-container';
const _track = (eventName, properties) => {
  const namespace = 'Pricing Pages';
  getPrimaryTracker().track(namespace, eventName, properties);
};
export const trackPageView = properties => {
  _track('Pageview', properties);
};
export const trackPageViewWithLastKnownEventProperties = properties => {
  _track('Pageview', properties);
};
export const trackAdditionalUnitsPicker = properties => {
  _track('Additional Units Picker', properties);
};
export const trackClickedLink = properties => {
  _track('Link Click', properties);
};
export const trackModalInteraction = properties => {
  _track('Modal Interaction', properties);
};
export const trackNavigationClick = properties => {
  _track('Navigation Click', properties);
};

/**
 * Generic button click tracker, prefer using more specific button click trackers if available
 */
export const trackButtonClick = properties => {
  _track('Button Click', properties);
};
export const trackTalkToSalesClick = properties => {
  const props = Object.assign({}, properties, {
    action: 'click talk to sales'
  });
  trackButtonClick(props);
};
export const trackBuyButtonClick = properties => {
  const props = Object.assign({}, properties, {
    action: 'clicked buy button'
  });
  trackButtonClick(props);
};
export const trackSignupButtonClick = properties => {
  const props = Object.assign({}, properties, {
    action: 'clicked signup button'
  });
  trackButtonClick(props);
};
export const trackTrialButtonClick = properties => {
  const props = Object.assign({}, properties, {
    action: 'clicked trial button'
  });
  trackButtonClick(props);
};
export const trackProductClick = properties => {
  _track('Product Click', properties);
};
export const trackScrollInteraction = properties => {
  _track('Scroll Interaction', properties);
};
export const trackFaqInteraction = properties => {
  _track('Faq Interaction', properties);
};
export const trackBannerInteraction = properties => {
  _track('Banner Interaction', properties);
};
export const trackCurrencyPickerInteraction = properties => {
  _track('Currency Picker Interaction', properties);
};
export const trackTermSelectorInteraction = properties => {
  _track('Term Selector Interaction', properties);
};
export const trackCommunicationMethodsInteraction = properties => {
  _track('Communication Methods Interaction', properties);
};
export const trackPlanBuilderInteraction = properties => {
  _track('Plan Builder Interaction', properties);
};
export const trackTooltipInteraction = properties => {
  _track('Tool Tip Interaction', properties);
};
const trackMultimediaInteraction = properties => {
  _track('Multimedia Interaction', properties);
};
export const trackVideoInteraction = properties => {
  const props = Object.assign({}, properties, {
    type: 'video'
  });
  trackMultimediaInteraction(props);
};
export const trackImageInteraction = properties => {
  const props = Object.assign({}, properties, {
    type: 'image'
  });
  trackMultimediaInteraction(props);
};
export const trackSectionViewed = properties => {
  _track('Section Viewed', properties);
};
export const trackFormInteraction = properties => {
  _track('Form Interaction', properties);
};
export const trackPurchaseMotionsViewed = properties => {
  _track('Purchase Motions Viewed', properties);
};
export const trackPromotionBannerViewed = params => {
  _track('interaction', Object.assign({}, params, {
    action: PROMOTION_BANNER_VIEWED
  }));
};